export default __webpack_public_path__ + "static/media/burned_v_light.b3c1c560.png";